import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from "@ngrx/store";
import { acsFeatureKey, reducer } from "./state/acs.reducer";
import { EffectsModule } from "@ngrx/effects";
import { AcsEffects } from "./state/acs.effects";
import { ChatApiService } from "./chat-api.service";
import { AcsCredentialsFacade } from "./acs-credentials.facade";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(acsFeatureKey, reducer),
        EffectsModule.forFeature([AcsEffects]),
    ],
    providers: [
        ChatApiService,
        AcsCredentialsFacade,
    ],
})
export class LiveLessonSharedDataAccessAcsModule {}
